import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { formatDateString } from "./fulfillment-group-csv-utils";

export const PackingSlipPrintedAtCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Packing slip printed at",
    cell: (row) =>
      formatDateString(row.printStatus?.packingSlipPrintedAt?.toISOString()),
  };
